import {Directive} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  Validator,
} from '@angular/forms';
import {PasswordPolicy} from '../../models/passwordPolicy';
import {PasswordPolicyService} from '../../services/password-policy';

@Directive({
  selector: '[ldValidatePassword][ngModel]',
  providers: [ PasswordPolicyService,
    {provide: NG_VALIDATORS,  useExisting: PasswordPolicyValidatorDirective, multi: true}
  ]
})
export class PasswordPolicyValidatorDirective implements Validator {

  private passwordPolicy: PasswordPolicy;

  constructor(private passwordPolicyService: PasswordPolicyService) {
    this.passwordPolicy = passwordPolicyService.getDefaultPasswordPolicy();
  }

  validate(control: AbstractControl) {
    let errors = Object.assign({},
      this.passwordLengthValidator(control),
      this.passwordLowercaseValidator(control),
      this.passwordUppercaseValidator(control),
      this.passwordNumberOfDigitsValidator(control));

    return Object.keys(errors).length < 1 ? null : errors;
  }

  private get length() {
      return Math.max(
        this.passwordPolicy.length || Number.MIN_VALUE
      );
    }

  private passwordLength(password: AbstractControl) {
      return password && password.value ? password.value.length : 0;
    }

  private passwordLengthValidator(password: AbstractControl) {
      return this.passwordLength(password) < this.length ? {
        passwordLength: true
      } : null;
    }

  private getErrorObject(errorCode: string) {
    const error = {};
    error[errorCode] = true;
    return error;
  }

  private passwordRegexValidator(password: AbstractControl, passwordPolicyProperty, regex: RegExp, errorCode: string) {
      if (this.passwordPolicy[passwordPolicyProperty] && !regex.test(password.value)) {
        return this.getErrorObject(errorCode);
      }
      return null;
    }

  private passwordLowercaseValidator(password: AbstractControl) {
      if (password.value === null || password.value === undefined) {
        return this.getErrorObject('passwordLowerCase');
      } else {
        return this.passwordRegexValidator(
          password, 'lowerCase',
          new RegExp(`[a-z]{1,${this.passwordPolicy.lowerCase}}`),
          'passwordLowerCase'
        );
      }
    }

  private passwordUppercaseValidator(password: AbstractControl) {
      return this.passwordRegexValidator(
        password, 'upperCase',
        new RegExp(`[A-Z]{1,${this.passwordPolicy.upperCase}}`),
        'passwordUpperCase'
      );
    }

  private passwordNumberOfDigitsValidator(password: AbstractControl) {
      return this.passwordRegexValidator(
        password, 'numberOfDigits',
        new RegExp(`[0-9]{1,${this.passwordPolicy.numberOfDigits}}`),
        'passwordNumberOfDigits'
      );
    }

}
